export default __webpack_public_path__ + "static/media/contact.7e57f01c.png";